import React from 'react';
import PropTypes from 'prop-types';
import { Link01 } from '@opendate-app/setlist';
import { conductorTheme } from '../themeTokens';

const ThreadContinuationNotice = ({ handoff }) => {
  if (!handoff?.summary) return null;

  return (
    <div style={{ margin: '12px 20px 4px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          color: conductorTheme.textMuted,
          marginBottom: '10px'
        }}
      >
        <span style={{ flex: 1, height: '1px', backgroundColor: conductorTheme.border }} />
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '11px',
          fontWeight: 600,
          whiteSpace: 'nowrap'
        }}>
          <Link01 width={12} height={12} aria-hidden="true" />
          Continued from a previous conversation
        </span>
        <span style={{ flex: 1, height: '1px', backgroundColor: conductorTheme.border }} />
      </div>
      <div
        style={{
          padding: '10px 12px',
          borderRadius: '10px',
          border: `1px solid ${conductorTheme.border}`,
          backgroundColor: conductorTheme.surfaceSoft,
          color: conductorTheme.textSlate,
          fontSize: '12.5px',
          lineHeight: 1.5,
          whiteSpace: 'pre-wrap'
        }}
      >
        {handoff.summary}
      </div>
    </div>
  );
};

ThreadContinuationNotice.propTypes = {
  handoff: PropTypes.shape({
    source_thread_id: PropTypes.number,
    summary: PropTypes.string
  })
};

ThreadContinuationNotice.defaultProps = {
  handoff: null
};

export default ThreadContinuationNotice;
